import { Component, Input, OnInit } from '@angular/core';
import { WidgetComponent } from 'app/widget/widgets/widget-component';
import { DashboardService } from '@widgets/services/dashboard.service';

@Component({
  selector: 'lms-autoevaluation-widget',
  templateUrl: './autoevaluation-widget.component.html',
  styleUrls: ['./autoevaluation-widget.component.scss']
})
export class AutoevaluationWidgetComponent implements WidgetComponent, OnInit {
  @Input() data: any;
  public autoevaluations: any;

  constructor(public dashboardService: DashboardService) {}

  ngOnInit() {
    const { group } = this.data;
    this.dashboardService
      .getClientWidget(group.clientId, 'autoevaluations', { groupId: group.id })
      .subscribe((data) => {
        this.autoevaluations = { coursesAutoevaluations: !data.empty ? data.courses : data, group };
      });
  }

  ngOnDestroy(): void {}
}
